<template>
  <header class="half-sheet-swipe-close flex flex-col z-10">
    <div
      class="flex shrink-0 justify-between items-center cursor-pointer bg-gray-50 p-4 lg:pointer-events-none"
      @click="$theme.sheet.close()"
    >
      <div
        v-if="totalQuantity > 0"
        class="bundle-summary-title transition-all flex flex-row gap-2 items-center rounded-full text-black font-bold select-none"
      >
        <span v-if="totalQuantity < MIN_SIZE">
          {{ $bt('min_size_prompt', bundleType, { minSize: MIN_SIZE }) }}
        </span>
        <span v-else-if="validSize">
          {{ $t('bundler.meals_in_box', { totalQuantity }) }}
        </span>
        <span v-else>
          {{ $bt('choose_valid_size', bundleType) }}
        </span>
      </div>
      <div
        v-else
        class="text-black font-bold"
      >
        {{ $t('bundler.shopping_cart') }}
      </div>
      <button
        v-if="$breakpoints.lg.value"
        class="flex-center rounded-full bg-white border border-green-500 text-sm px-3 py-0.5"
        data-gtm-action="bundle summary - collapse"
        aria-label="collapse"
      >
        {{ $t('bundler.close_cart') }}
      </button>
    </div>
    <BundleSummaryProgress />
  </header>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBundleStore } from '@/stores'
import BundleSummaryProgress from './bundle-summary-progress.vue'
const store = useBundleStore()
const { bundleType, MIN_SIZE } = store
const { totalQuantity, validSize } = storeToRefs(store)
</script>
